import type { IntelSource } from '../../../types/intel-source.js';

const STALE_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

/** A source whose last content is older than a week. A source that never produced content is not stale. */
export function isStale(source: IntelSource): boolean {
  if (!source.lastContentAt) return false;
  return Date.now() - new Date(source.lastContentAt).getTime() > STALE_AFTER_MS;
}

/** Whole days since the source's last content (0 when it never had any). */
export function staleDays(source: IntelSource): number {
  if (!source.lastContentAt) return 0;
  return Math.floor((Date.now() - new Date(source.lastContentAt).getTime()) / 86_400_000);
}
